import FormAbandonOptout from '@/components/FormAbandonOptout'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: FormAbandonOptout,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}
